// SORTING
// tanstack default sort is a simple "contains". It doesn't work for NA filters, so we need to override it.
export const defaultSort = (row, columnId, filterValue) => {
	const cellValue = row.getValue(columnId);

	if (filterValue === NA_FILTER_VALUE) {
		return cellValue == null || cellValue === "" || cellValue === " ";
	}

	if (!cellValue) return false;

	const normalized = cellValue.toString().toLowerCase();

	return normalized.includes(filterValue.toLowerCase());
};

// strictSort: function for strict column sorting, exact matches, used for filtering things like id
export const strictSort = (row, columnId, filterValue) => {
	const cellValue = row.getValue(columnId);

	if (filterValue === NA_FILTER_VALUE) {
		return cellValue == null || cellValue === "";
	}

	if (cellValue === null || cellValue === undefined) return false;

	const normalized = cellValue.toString().toLowerCase();

	return normalized === filterValue.toLowerCase();
};

// splitSort: function for sorting checkbox filters like assemblies, groupings etc. If they are stored with "_SPLIT_" method
export const splitSort = (row, columnId, filterValues) => {
	const rawValue = row.getValue(columnId);

	if (filterValues === NA_FILTER_VALUE) {
		return !rawValue;
	}

	if (!rawValue) return false;

	const tokens = rawValue.split("_SPLIT_").map((s) => s.trim().toLowerCase());

	return filterValues.every((val) => tokens.includes(val.toLowerCase()));
};

// checkboxSort: function for sorting checkbox filters like status, used for if there is one checkbox value per row
export const checkboxSort = (row, columnId, filterValues) => {
	const cellValue = row.getValue(columnId);

	if (filterValues === NA_FILTER_VALUE) {
		return !cellValue;
	}

	if (cellValue === null || cellValue === undefined) return false;

	// If value is string, normalize to lowercase
	const normalized =
		typeof cellValue === "string" ? cellValue.toLowerCase() : cellValue;

	return filterValues.some((val) => {
		const compareVal = typeof val === "string" ? val.toLowerCase() : val;
		return compareVal === normalized;
	});
};

// dateSort: function for sorting date filters, used for filtering things like created_at
export const dateSort = (row, columnId, filterValue) => {
	const cellValue = row.getValue(columnId);

	if (filterValue === NA_FILTER_VALUE) {
		return !cellValue;
	}

	if (!cellValue) return false;

	const dateValue = new Date(cellValue);
	const start = new Date(filterValue.start);
	const end = new Date(filterValue.end);

	return dateValue >= start && dateValue <= end;
};

// OTHER

// "not applicable" styled text used in the table when no value is present or it's N/A
export const notApplicable = (
	<span style={{ color: "gray", fontStyle: "italic" }}>N/A</span>
);

export const NA_FILTER_VALUE = "__ONLY_NA__";

export const EARLIEST_DATE = new Date("1970-01-01T00:00:00Z");
